import cuid from "cuid";

import { serverNow } from "@storyboard/web-client";
import { store } from "@/store/store";
import type { AssignmentTarget, DispatchAssignmentRow } from "@/store/types";

/** Who is handing off, in which workspace: stamped on every row the prototype writes. */
export type AssignmentWriter = { workspaceId: string; actorMembershipId: string | null };

/** What a handoff names before it gets an id: one target, who it goes to (or `null` to clear), and the note. */
export type AssignmentIntent = {
  targetKind: "feed_item" | "anchor";
  targetId: string;
  feedId: string;
  assignee: AssignmentTarget | null;
  note: string | null;
};

/**
 * Mints one row per intent (cuid id, serverNow() createdAt) and upserts them into `dispatchAssignment`.
 *
 * The reassignment prototype's only write: the rows live in this browser's store, persisted by its snapshot, and are
 * never sent to the server.
 */
export function recordAssignments(writer: AssignmentWriter, intents: readonly AssignmentIntent[]): void {
  if (intents.length === 0) return;
  const createdAt = serverNow().toISOString();
  const rows: DispatchAssignmentRow[] = intents.map((intent) => ({
    id: cuid(),
    workspaceId: writer.workspaceId,
    targetKind: intent.targetKind,
    targetId: intent.targetId,
    feedId: intent.feedId,
    assignee: intent.assignee,
    note: intent.note,
    actorMembershipId: writer.actorMembershipId,
    createdAt,
  }));
  store.upsert("dispatchAssignment", rows);
}
